import React from "react";
import { Form, Button, Card, Badge } from "react-bootstrap";
import moment from "moment";

const ProjectBoardTab = ({
  boardGroupBy,
  setBoardGroupBy,
  getBoardColumns,
  getPriorityBadge,
  getStatusBadge,
  handleEditTask,
}) => {
  return (
    <div className="project-view-fade-in">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center">
          <h5 className="text-white me-3">Board View</h5>

          <Form.Select
            size="sm"
            value={boardGroupBy}
            onChange={(e) => setBoardGroupBy(e.target.value)}
            style={{ width: "200px" }}
          >
            <option value="status">Group by Status</option>
            <option value="priority">Group by Priority</option>
            <option value="assignee">Group by Assignee</option>
            <option value="stage">Group by Stage</option>
          </Form.Select>
        </div>
      </div>

      {/* Board Columns */}
      <div className="project-view-board-container d-flex overflow-auto">
        {Object.entries(getBoardColumns()).map(([columnName, columnTasks]) => (
          <div key={columnName} className="project-view-board-column me-3">
            <div className="project-view-board-column-header">
              <h6>{columnName}</h6>
              <span className="badge bg-secondary">{columnTasks.length}</span>
            </div>

            <div className="project-view-board-column-body">
              {columnTasks.map((task) => (
                <Card
                  key={task.taskId}
                  className="project-view-board-task-card mb-2"
                  style={{ cursor: "pointer" }}
                >
                  <Card.Body>
                    <div className="fw-bold">{task.taskName}</div>

                    <small className="text-muted">
                      {task.taskDescription || "-"}
                    </small>

                    <div className="mt-2 d-flex justify-content-between">
                      <Badge className={getPriorityBadge(task.taskPriority)}>
                        {task.taskPriority || "No Priority"}
                      </Badge>

                      <Badge className={getStatusBadge(task.taskStatus)}>
                        {task.taskStatus || "No Status"}
                      </Badge>
                    </div>
                  </Card.Body>

                  {/* Hover Detail Panel */}
                  <div className="project-view-board-hover-detail">
                    <div className="hover-header d-flex justify-content-between align-items-center">
                      <h6 className="mb-0">{task.taskName}</h6>

                      <i
                        className="fas fa-pencil-alt project-view-edit-icon"
                        onClick={() => handleEditTask(task.taskId)}
                      ></i>
                    </div>

                    <hr />

                    <p>
                      <strong>Description:</strong>{" "}
                      {task.taskDescription || "No description"}
                    </p>

                    <p>
                      <strong>Priority:</strong>{" "}
                      {task.taskPriority || "No Priority"}
                    </p>
                    <p>
                      <strong>Status:</strong> {task.taskStatus || "No Status"}
                    </p>

                    <p>
                      <strong>Start:</strong>{" "}
                      {task.taskStartDate
                        ? moment(task.taskStartDate).format("MMM DD, YYYY")
                        : "-"}
                    </p>
                    <p>
                      <strong>End:</strong>{" "}
                      {task.taskEndDate
                        ? moment(task.taskEndDate).format("MMM DD, YYYY")
                        : "-"}
                    </p>

                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={() => handleEditTask(task.taskId)}
                      className="w-100 mt-2"
                    >
                      Edit Task
                    </Button>
                  </div>
                </Card>
              ))}

              {columnTasks.length === 0 && (
                <div className="text-muted text-center py-3">No tasks</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectBoardTab;
